const docsBookmarks = {
  headDocs: 'headDocs',
  segments: 'chapter06',
  funnels: 'chapter05',
  retention: 'chapter07',
  retentionComplex: 'chapter0702',
  retentionTimeRange: 'chapter0703',
  revenue: 'chapter09',
  users: 'chapter10',
  fields: 'chapter02',
  labels: 'chapter03',
  usage: 'chapter08',
  dashboards: 'chapter13',
};

export default docsBookmarks;
